// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_XuV9stAxmwaJ3QVj40cg","holding":"_2El_0NI9B72wShfKa1RtBn","inner":"_1Fvy8rWh6YHvA-nuirtpxL"};